import { Pipe, PipeTransform } from '@angular/core';
import { ETypes } from '@meeting/models/meeting-type.interface';

@Pipe({
  name: 'meetingTypes',
  pure: true,
})
export class MeetingTypesPipe implements PipeTransform {
  transform(types: ETypes): string {
    switch (types) {
      case ETypes.ANNUAL:
        return 'MEETING.ANNUAL_MEETING';
      case ETypes.DAY_RATE:
        return 'MEETING.DAY_RATE_MEETING';
      case ETypes.DISCONNECT:
        return 'MEETING.DISCONNECT_MEETING';
      case ETypes.END_OF_TRIAL:
        return 'MEETING.END_OF_TRIAL_MEETING';
      case ETypes.INTERNAL_MOBILITY_FOLLOW_UP:
        return 'MEETING.INTERNAL_MOBILITY_FOLLOW_UP';
      case ETypes.OFF_BOARDING:
        return 'MEETING.OFF_BOARDING';
      case ETypes.PROFESSIONAL:
        return 'MEETING.PROFESSIONAL_MEETING';
      case ETypes.RETURN:
        return 'MEETING.RETURN_MEETING';
      case ETypes.SIX_YEARS:
        return 'MEETING.SIX_YEARS_MEETING';
      case ETypes.TRIAL_PERIOD_FOLLOW_UP:
        return 'MEETING.TRIAL_PERIOD_FOLLOW_UP';
      case ETypes.CAREER_DEVELOPMENT:
        return 'MEETING.CAREER_DEVELOPMENT';
      case ETypes.PROGRESS:
        return 'MEETING.PROGRESS';
      case ETypes.MID_CAREER:
        return 'MEETING.MID_CAREER';
      case ETypes.PRE_60_CAREER:
        return 'MEETING.PRE_60_CAREER';
      default:
        return '';
    }
  }
}
